import { shallowEqual, useSelector } from 'react-redux';
import ReactAudioPlayer from 'react-audio-player';

import PlayOrRecord from '../assets/audio/record_or_play_instructions.mp3';
import MediaService from '../../../../services/MediaService';

import './SingingPage.scss';

const SingingPageIntro = ({ onPlayClick, onRecordClick, moduleName, singAlongMessage}) => {
  const { login } = useSelector((state) => state.loginReducer, shallowEqual);

  const moduleFullName ={
    'MODULE1': 'Eye Contact',
    'MODULE2': 'Listening',
    'MODULE3': 'Facial Expressions',
    'MODULE4': 'Posture',
    'MODULE5': 'Distance',
  }

  const recordIcon = MediaService.getImage(
    '/Module1Images/Record-Small_3x.png',
    login
  );

  const playIcon = MediaService.getImage(
    '/Module1Images/Play-small_3x.png',
    login
  );

  return (
    <>
      {!singAlongMessage && <ReactAudioPlayer src={PlayOrRecord} autoPlay />}

      <div className='sing-message'>
        <h3>
          It&apos;s now time for {login.firstname} to record the {moduleFullName[moduleName]} song.
        </h3>
        <h3>To listen to the song, press play.</h3>
        <h3>To begin recording, press record.</h3>
      </div>

      <div className='sing-actions'>
        <button onClick={onPlayClick}>
          <img src={playIcon} alt='play' />
        </button>
        <button onClick={() => {onRecordClick()}}>
          <img src={recordIcon} alt='record' />
        </button>
      </div>
    </>
  );
};

export default SingingPageIntro;
